// extracted by mini-css-extract-plugin
export default {"wrapper":"noData_wrapper__Zx2Et"};